import { SearchBoxChangeEvent } from "@fluentui/react-components";
import React, { useContext } from "react";
import { LayoutContext } from "../../context/LayoutContext";
import Sidebar from "../common/sidebar/Sidebar";
import { FlightDetails } from "../shared/components/airport-cards/flights/tab-content/FlightDetails";
import { OverviewCarousel } from "./OverviewCarousel";

interface IAirportListProps {
  sideBarActive: boolean;
  setSideBarActive: any;
  searchInputHandler: (event: SearchBoxChangeEvent) => void;
  airportCode: string;
}
export const OverviewSidebar: React.FC<IAirportListProps> = ({
  sideBarActive,
  setSideBarActive,
  searchInputHandler,
  airportCode,
}) => {
  const { selectedFlight, setSelectedFlight } = useContext(LayoutContext);
  const showFlightDetails = selectedFlight?.flightDocID !== undefined;

  return (
    <Sidebar
      sideBarActive={sideBarActive}
      setSideBarActive={setSideBarActive}
      searchInputHandler={searchInputHandler}
      overlayActive={showFlightDetails}
      overlay={
        <FlightDetails
          setSelectedFlight={setSelectedFlight}
          selectedFlight={selectedFlight}
        />
      }
    >
      <OverviewCarousel airportCode={airportCode} />
    </Sidebar>
  );
};
